/** Formats 24h "HH:mm" or "HH:mm:ss" values for display with AM/PM. */
export var formatMeetingTime = function (time) {
    if (!(time === null || time === void 0 ? void 0 : time.trim()))
        return "";
    var trimmed = time.trim();
    // Already contains AM/PM
    if (/am|pm/i.test(trimmed)) {
        return trimmed;
    }
    var match = trimmed.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/);
    if (!match)
        return trimmed;
    var hours = Number(match[1]);
    var minutes = match[2];
    if (Number.isNaN(hours) || hours > 23)
        return trimmed;
    var period = hours >= 12 ? "PM" : "AM";
    var hour12 = hours % 12 || 12;
    return "".concat(hour12, ":").concat(minutes, " ").concat(period);
};
/** Converts display or picker time to 24h "HH:mm" for API storage. */
export var toMeetingTime24h = function (time) {
    if (!(time === null || time === void 0 ? void 0 : time.trim()))
        return "";
    var trimmed = time.trim();
    var amPmMatch = trimmed.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
    if (amPmMatch) {
        var hours = Number(amPmMatch[1]);
        var minutes = amPmMatch[2];
        var period = amPmMatch[3].toUpperCase();
        if (period === "PM" && hours < 12)
            hours += 12;
        if (period === "AM" && hours === 12)
            hours = 0;
        return "".concat(String(hours).padStart(2, "0"), ":").concat(minutes);
    }
    var match = trimmed.match(/^(\d{1,2}):(\d{2})/);
    if (!match)
        return trimmed;
    return "".concat(String(Number(match[1])).padStart(2, "0"), ":").concat(match[2]);
};
export var getGoogleMapsUrl = function (place, latitude, longitude) {
    if (latitude != null && longitude != null && !Number.isNaN(latitude) && !Number.isNaN(longitude)) {
        return "https://www.google.com/maps/search/?api=1&query=".concat(latitude, ",").concat(longitude);
    }
    if (place === null || place === void 0 ? void 0 : place.trim()) {
        return "https://www.google.com/maps/search/?api=1&query=".concat(encodeURIComponent(place.trim()));
    }
    return null;
};
